import React from 'react';

import { styled } from '@mui/material/styles';
import optionsTabsStyles from './OptionsTabsStyles';

import Separator from '../Separator/Separator';
import Tabbar from '../Tabbar/Tabbar';

type OptionsTabsProps = {
  tabs: Array<{
    id: string;
    label: string;
    title: string;
    description: React.ReactNode;
    image: string;
  }>;
};

const StyledCard = styled('section')(({ theme }) => optionsTabsStyles);

const OptionsTabs:React.FC<OptionsTabsProps> = (props) => {
  const { tabs } = props;

  return (
    <StyledCard className="flex-col items-center flex" id="options-section">
      <div className='w-full flex justify-center'>
        <h2 className="container pt-[4rem] lg:pt-[8rem] text-4xl lg:text-6xl font-semibold text-center pb-[2rem] lg:pb-[1.5rem] px-4 text-wrap w-fit">Tipos de cajas secas</h2>
      </div>
      <div className="flex flex-col align-middle justify-center my-4">
        <Separator className="mb-10"/>
        <div className="text-xl max-w-[54rem] text-center mx-8 md:mx-24 mb-8">Descubre las capacidades, medidas y configuraciones de nuestras cajas secas, diseñadas para adaptarse a distintos tipos de carga y necesidades de transporte.</div>
      </div>
      <div className="container flex flex-col items-center justify-center lg:items-stretch lg:flex-row flex-wrap mb-8 md:mb-36">
        <Tabbar tabs={tabs}/>
      </div>
    </StyledCard>
  )
}

export default OptionsTabs;